import initialState from './initialState';
import { types } from '../actions/cmsActions';

export default function cmsReducer(state = initialState.cms, action) {
  switch (action.type) {
    case types.LOAD_CMS_DATA_SUCCESS:
    {
      return { ...action.cms };
    }
    case types.UPDATE_CMS_DATA_LOCATION: {
      const { location } = action;
      return { ...state, location };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/cmsReducer.js